/**
 * Per-client feature flag registry. Add an entry when this client starts
 * consuming a flag. Each value MUST match the gate name in the Statsig
 * Console and the backend registry
 * (spark/services/shared/src/shared/feature_flags/flags.py).
 *
 * IMPORTANT: Create the gate in Statsig Console BEFORE adding here.
 */
export const FeatureFlag = {
  EXTERNAL_SAML_IDP: 'external_saml_idp',
  MCPGW_FRONT_DOOR: 'mcpgw_front_door',
  MCP_SERVER_TESTER: 'mcp_server_tester',
  ONE_TIME_MCP_APPROVAL: 'one_time_mcp_approval',
} as const;

export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];
